<ui-modal [modalTitle]="title ? 'Mark ' + title + ' as Lost' : 'Mark deal as Lost'" size="lg">

	<div *ngIf="loading" class="text-center py-4">
		<div class="spinner-border text-secondary"></div>
	</div>

	<ng-container *ngIf="!loading">

		<!-- From the quote screen: the cancel is what loses the deal, so it is only the reason. -->
		<p *ngIf="quoteMode" class="text-secondary">
			This is the last quote still in play on
			<b *ngIf="title">{{title}}</b><ng-container *ngIf="!title">its deal</ng-container>,
			so {{actionVerb}} it moves the deal to <b>{{stage}}</b>.
		</p>

		<!-- Why it cannot be lost, before a reason is typed rather than after (CRM-175). The quotes
		     are still listed below it, so the refusal can be read against what is in play. -->
		<div *ngIf="!quoteMode && blocked" class="alert alert-danger d-flex align-items-start">
			<i class="wq wq-warning mr-2 mt-1"></i>
			<div>{{blocked}}</div>
		</div>

		<ng-container *ngIf="!quoteMode && preview">
			<p *ngIf="!quoteConnected" class="text-secondary">
				The deal moves to <b>{{stage}}</b>. Its quotes are not changed — this pipeline does not follow them.
			</p>
			<p *ngIf="quoteConnected && !quotes.length" class="text-secondary">
				This deal has no quote in play, so it moves straight to <b>{{stage}}</b>.
			</p>

			<!-- Named before it happens: on this pipeline the deal is Lost because no quote is left
			     in play, so losing it is cancelling every one that is (D-069). -->
			<ng-container *ngIf="quoteConnected && quotes.length">
				<p class="text-secondary mb-2">
					<ng-container *ngIf="!blocked">
						{{quoteCount === 1 ? 'This quote' : 'These ' + quoteCount + ' quotes'}} will be cancelled — that is
						what moves the deal to <b>{{stage}}</b>.<ng-container *ngIf="hasChangeOrders"> {{quoteCount === 1 ? 'Its' : 'Their'}} change
							orders are cancelled with {{quoteCount === 1 ? 'it' : 'them'}}.</ng-container>
					</ng-container>
					<ng-container *ngIf="blocked">Still in play on this deal:</ng-container>
				</p>

				<div class="border rounded mb-3">
					<div *ngFor="let q of quotes; let i = index; let last = last" class="d-flex align-items-center px-3 py-2"
							[ngClass]="{ 'border-bottom': !last, 'pl-5': underQuote(i) }">
						<div class="flex-weight-1">
							<div class="text-bold">{{rowLabel(q)}}</div>
							<div *ngIf="!q.change_order" class="text-secondary text-small">{{q.description || 'No name'}}</div>
							<div *ngIf="q.change_order && !underQuote(i)" class="text-secondary text-small">On quote {{q.quote_no}}</div>
						</div>
						<span class="badge mr-3" [ngClass]="stageBadge(q.stage)">{{stageLabel(q.stage)}}</span>
						<div *ngIf="q.net_total !== null" class="text-right nowrap">
							<div class="text-bold">{{q.net_total | currency:q.currency_id}}</div>
							<div class="text-secondary text-small">excl. tax</div>
						</div>
					</div>
				</div>

				<!-- Signed work said on its own line: cancelling it is not the same act as cancelling a
				     quote nobody agreed to. Reopen is offered as the other thing only where it would
				     work — the server's reopen plan says so (no change orders, no issued invoice). -->
				<div *ngIf="!blocked && signedQuotes.length" class="alert alert-warning py-2 px-3 text-small">
					<b>{{signedQuotes[0].quote_no}} is accepted</b> — losing the deal cancels the signed quote too.
					<ng-container *ngIf="reopenable">To reverse the acceptance and bring the alternatives back instead,
						use <b>Reopen deal</b>.</ng-container>
				</div>

			</ng-container>
		</ng-container>

		<!-- Money already billed, in its own alert, on the deal page and the quote screen alike: none
		     of these changes touches an invoice, so this is what the click leaves standing, not
		     what it does. Amounts are left out for somebody who may not see the deal's values. -->
		<div *ngIf="invoiceRows.length" class="alert alert-danger py-2 px-3 text-small">
			<div class="text-bold mb-1"><i class="wq wq-warning mr-1"></i>There are invoices against this work</div>
			<div *ngFor="let q of invoiceRows">
				<b>{{q.quote_no || 'This quote'}}</b> —
				{{q.billed.invoice_count}} {{+q.billed.invoice_count === 1 ? 'invoice' : 'invoices'}}<ng-container *ngIf="q.billed.invoiced !== null">,
				{{q.billed.invoiced | currency:q.currency_id}} invoiced<ng-container *ngIf="+q.billed.paid > 0">,
				<b>{{q.billed.paid | currency:q.currency_id}} paid</b></ng-container></ng-container>.
			</div>
			<div class="mt-1">{{invoiceNote}}</div>
		</div>

		<div *ngIf="quoteMode || (preview && !blocked)" class="form-group mb-0">
			<label>Why was this deal lost? <span class="text-primary">*</span></label>
			<textarea class="form-control" rows="3" [maxlength]="maxLength" [(ngModel)]="reason" [ngModelOptions]="{ standalone: true }"
				placeholder="e.g. Chose a competitor on price" appDesktopFocus></textarea>
			<small class="form-text text-secondary">
				Lost reasons are grouped on Sales Overview, so this is the field that answers "why are we losing?" later.
			</small>
		</div>

	</ng-container>

	<button type="button" class="btn btn-secondary" (click)="cancel()" ui-modal-footer>{{quoteMode ? 'Keep quote' : 'Cancel'}}</button>
	<button *ngIf="quoteMode || !blocked" type="button" class="btn btn-primary" (click)="confirm()" [disabled]="!canConfirm" ui-modal-footer>
		{{quoteMode ? actionButton : 'Mark as Lost'}}
	</button>
</ui-modal>
